import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { useImmer } from 'use-immer';
import { validatePlayerCodeApi } from '../apis';
import { useAppStateContext } from '@/shared';

export const usePageSignIn = () => {
  const navigate = useNavigate();
  const [state, setState] = useImmer({
    isSubmitting: false,
  });

  const { appState, setAppState } = useAppStateContext();

  const FormSchema = z.object({
    playerCode: z
      .string()
      .trim()
      .min(1, { message: 'Player code must be min 1 character.' })
      .max(6, {
        message: 'Player code must be max 6 characters.',
      }),
  });

  const form = useForm({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      playerCode: '',
    },
  });

  // ========================================================= API SECTION ================================================================
  const doSignIn = async (params) => {
    triggerLoading(true);
    try {
      const response = await validatePlayerCodeApi(params);
      const { data } = response;
      if (response.status === 200) {
        const formattedData = { ...appState, tid: data };
        setAppState(formattedData);

        navigate('/device/config', { replace: true });
      } else {
        throw response;
      }
    } catch (error) {
      const message = error.response.data.message ?? 'Unable to connect';
      form.setError('playerCode', { message });
    } finally {
      triggerLoading(false);
    }
  };

  // ========================================================= UTIL FUNCTION SECTION ================================================================
  const triggerLoading = (loading) => {
    setState((draft) => {
      draft.isSubmitting = loading;
    });
  };

  const onSubmit = async (data) => {
    await doSignIn(data);
  };

  return { state, form, onSubmit };
};
